import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
};

export const gallerySlice = createSlice({
  name: 'gallery',
  initialState,
  reducers: {
    getGalleries: (state) => {
      state.loading = true;
    },
    successGallery: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    failedGallery: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getGalleries,
  successGallery,
  failedGallery,
} = gallerySlice.actions;

export default gallerySlice.reducer;
